import { $authHost } from ".."

// Тут випадково дублював файл. Вірний знаходитсья в папці "pack". Це теж працююче, але не додавати сюди

export const transferSeriesInFactoryLineAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/serieses/transfer_series_to_factory`, dataForBd)
    return data
}